import * as React from "react";

import { RESULTS_PAGE_TO_PRESENT, usePlpPresenterForRoutingTheResultsPage } from "./providers";

import { AppLoading } from "./app-loading";
import { PageResults } from "./page-results";
import { PageNoResults } from "./page-no-results";
import { PageUndefined } from "./page-undefined";
import { IS_HORIZONTAL_FILTER_ENABLED } from "./flags";

export const PageContents: React.FunctionComponent = () => {
  const { pageToPresent } = usePlpPresenterForRoutingTheResultsPage();

  return (
    <section
      className={`bbnt-plp-page-contents${
        IS_HORIZONTAL_FILTER_ENABLED ? " is-horizontal-filter-enabled" : ""
      }`}
    >
      <AppLoading />

      {pageToPresent === RESULTS_PAGE_TO_PRESENT.PRODUCT_LIST && (
        <PageResults />
      )}
      {pageToPresent === RESULTS_PAGE_TO_PRESENT.ZERO_RESULTS && (
        <PageNoResults />
      )}
      {pageToPresent === RESULTS_PAGE_TO_PRESENT.UNDEFINED && <PageUndefined />}
    </section>
  );
};
